const VisitScheduleType = {
  now: 'now',
  scheduled: 'scheduled',
}

Object.freeze(VisitScheduleType)

export default VisitScheduleType
